import { prod } from "./prod";
import { dev } from "./dev";

export const config = process.env.NODE_ENV === "production" ? prod : dev;
